import React, { FunctionComponent, useMemo } from 'react';

import { FlightsLuggageProps } from './FlightsLuggage.types';
import { Wrapper } from './FlightsLuggage.style';
import { CabinLuggage, Luggage, NoLuggage, NoCabinLuggage } from './components/luggageIcons';
import { LuggageTypes } from '@lt/api/dist/methods/packages/types';

// Возвращает вес багажа, если количество > 0
export const getLuggageWeight = ({ count, weight }: LuggageTypes['hand']): number | undefined =>
  count && weight;

export const FlightsLuggage: FunctionComponent<FlightsLuggageProps> = ({
  luggage,
  className,
}) => {
  const { hold, hand } = luggage;
  const holdWeight = getLuggageWeight(hold);
  const handWeight = getLuggageWeight(hand);

  const LuggageIcon = useMemo(() => {
    if (!holdWeight) {
      return <NoLuggage />;
    }
    return <Luggage value={holdWeight} />;
  }, [holdWeight]);

  const CabinLuggageIcon = useMemo(() => {
    if (!handWeight) {
      return <NoCabinLuggage />;
    }
    return <CabinLuggage value={handWeight} />;
  }, [handWeight]);

  return (
    <Wrapper className={className}>
      {LuggageIcon}
      {CabinLuggageIcon}
    </Wrapper>
  );
};
